window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Require extra libraries.
window.popper         = require('@popperjs/core/dist/umd/popper.min');

window.bootstrap      = require('bootstrap/dist/js/bootstrap.bundle');
// window.bootstrapMin = require('bootstrap/')
window.moment         = require('moment');
window.select2        = require('select2');
window.poppercore = require('@popperjs/core');
window.tempusDominus = require('@eonasdan/tempus-dominus');
window.EasyMDE        = require('easymde');
window.dt             = require('datatables.net');
window.dtButtons      = require('datatables.net-buttons');
window.FullCalendar   = require('fullcalendar');
window.dtBs           = require('datatables.net-bs5');
window.tempusDominusDefaults = {
    localization: {
        locale: 'en',
    },
    display: {
        icons: {
            time: 'bi bi-clock',
            next: 'bi bi-arrow-right',
            date: 'bi bi-calendar',
            up: 'bi bi-arrow-up',
            down: 'bi bi-arrow-down',
            previous: 'bi bi-arrow-left',
            today: 'bi bi-calendar-check',
            clear: 'bi bi-trash',
            close: 'bi bi-x-square'
        },
    }
}
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
